import type { TaskBundle } from '@awork/features/task/models/task-bundle.model'
import type { ProjectStatus } from '@awork/features/project/models/project-status.model'
import type { ProjectType } from '@awork/features/project/models/project-type.model'

interface ITaskBundleAssignment {
  taskBundle: TaskBundle
  projectType: Partial<ProjectType>
  projectStatus?: Partial<ProjectStatus>
}

/**
 * Task Bundle Assignment
 * This is not an API model, but used here to link a project type and optionally a project status
 * to task bundle.
 */
export class TaskBundleAssignment implements ITaskBundleAssignment {
  taskBundle: TaskBundle
  projectType: ProjectType
  projectStatus?: ProjectStatus

  constructor(taskBundleAssignment: ITaskBundleAssignment) {
    Object.assign(this, taskBundleAssignment)
  }
}
